import { Box, Typography } from "@mui/material";
import { bodyTextSx, mutedTextSx } from "../../styles/cyberTheme";

export default function MemberInfoBar({ name, orgName }) {
    return (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 0.25 }}>
            <Typography sx={{ ...bodyTextSx, fontSize: "22px" }}>
                {name || "—"}
            </Typography>
            {orgName ? (
                <Typography sx={{ ...mutedTextSx, fontSize: "16px" }}>
                    {orgName}
                </Typography>
            ) : null}
        </Box>
    );
}
